export default __webpack_public_path__ + "images/FR.5bb3035.png";